import styled from 'styled-components';


export const CitiesBox = styled.div`
    background: #fff;
    border-radius: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 15px;
    flex-direction: column;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0px 10px 30px #00000014;  
    &:last-child{
        margin-bottom: 0px; 
    }
    @media screen and (max-width: 1024px){
        padding: 15px;
        border-radius: 15px;
    }
`;

export const CitiesBoxSubTitle = styled.h3`
    width: 100%;
    color: #333333;
    font-size: 16px;
    cursor:pointer;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid #99d3d6;
`;

export const CityNameList = styled.span`
    color: #333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 22px;
    cursor: pointer; 
`;